import { AppError } from "config/errors";
import { fetchAllWyshAllocationHistories } from "gql/queries/allocationHistory";
import { getActiveAccount } from "utils/account";

import { createAsyncThunk } from "@reduxjs/toolkit";

export const getAllWyshAllocationHistories = createAsyncThunk(
  "wyshes/allWyshAllocationHistories",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchAllWyshAllocationHistories();
      const activeAccount = getActiveAccount(response.data.me);

      return activeAccount?.allocationHistories || {};
    } catch (err) {
      return rejectWithValue(AppError.from(err).toPlainObject());
    }
  }
);
